import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnViewInstitutionalDistribution',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const authStore = useAuthStore()
const router = useRouter()

/**
 * ✅ REGRA DE EXIBIÇÃO
 */
const showDistributionButton = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanViewInstitutional &&
    !!status &&
    (
      status === CONST_INSTITUTIONAL_STATUS.PUBLISHED.id ||
      status === CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id ||
      status === CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id ||
      status === CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id
    )
  )
})

/**
 * ✅ IR PARA DISTRIBUIÇÃO
 */
const onViewInstitutionalDistribution = () => {
  const id = institutionalStore.institutionalDetail?.id

  if (!id) return

  router.push({
    name: EnumRouteNames.INSTITUTIONAL_DISTRIBUTION,
    params: { id }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (showDistributionButton.value)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-view-institutional-distribution",
        propBtnLabel: "Distribuição do Cadastro",
        propBtnFunction: onViewInstitutionalDistribution,
        propBtnTransparent: false,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})